module.exports = __webpack_public_path__ + "img/spins_7.45cbba0c.png";